<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container xl center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup account-detail">
        <div class="popup-title">
          <span class="hdg02">アカウント情報</span>
          <span class="txt-blue ml40 ga-admin-contract-account-edit" @click="openEdit" role="button">アカウント情報を編集する</span>
        </div>
        <div class="popup-content">
          <div class="account-detail-table">
            <table>
              <colgroup>
                <col style="width:16.666%;">
                <col style="width:83.333%;">
              </colgroup>
              <tbody>
                <tr>
                   <th><span class="hdg05">アカウントID</span></th>
                  <td>{{user.id}}</td>
                </tr>
                <tr>
                   <th><span class="hdg05">アカウント名</span></th>
                  <td class="no-padding">
                    <div class="account-detail-table-user">
                      <span class="account-detail-table-user-name">{{user.name}}</span>
                      <span v-if="user.file_id > 0" class="account-detail-table-user-thumb" :style="{backgroundImage : 'url(' + user.image + ')'}"></span>
                      <span v-else class="account-detail-table-user-thumb no-image">{{user.name.slice(0, 1)}}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                   <th><span class="hdg05">メールアドレス</span></th>
                  <td>{{user.email}}</td>
                </tr>
                <tr>
                    <th><span class="hdg05">権限</span></th>
                    <td>{{user.auth === 0 ? '利用者' : '管理者'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="user.products.length > 0" class="account-detail-table">
            <table>
              <colgroup>
                <col style="width:16.666%;">
                <col style="width:83.333%;">
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    <span class="hdg05">付与ライセンス</span>
                  </th>
                  <td class="no-input pr0">
                    <div class="account-detail-table-license">
                      <p v-for="(product, index) in user.products" :key="'product_' + index" class="txt">{{product.name}}</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAccountDetail } from '@/logic/contract/ContractAccountDetail'

export default defineComponent({
  name: 'PCContractAccountDetail',
  setup (props, context) {
    return { ...ContractAccountDetail(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-wrapper{
  .popup-container{
    .popup-title{
      padding: 26px 116px 25px 55px;
      .hdg02,
      .txt-blue {
        vertical-align: middle;
      }
    }
  }
  .popup-content{
    padding: 30px 50px 40px;
  }
}
.account-detail-table{
  border-bottom: 1px solid $color-content-nega;
  padding-bottom: 18px;
  table{
    width: 100%;
    border-collapse: collapse;
    th{
      text-align: left;
      vertical-align: top;
      span {
        color: $color-hdg02;
      }
    }
    th,td{
      font-size: 1.6rem;
      line-height: 1.625;
      padding: 8px 15px 8px 0;
      color: $color-content;
    }
    td{
      &.border-dash{
        border-top: 1px dashed $color-content-nega;
      }
      &.no-padding{
        padding: 0;
      }
    }
  }
  &-license{
    overflow: auto;
    max-height: 208px;
  }
  & + &{
    margin-top: 20px;
  }
  &-user{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    &-thumb{
      @include profileImage();
    }
  }
}
</style>
